// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"21289ed7","453":"e542b0ff","947":"eae1e591","952":"b189df59"}[chunkId] + ".chunk.js";
};